import { GenericError } from './GenericError';
/**
 * Helper class to signal an api request error with response code 403.
 */
export class AccessDeniedError extends GenericError {
    static className = 'AccessDeniedError';
    constructor(props) {
        super(props);
    }
    getStatusCode() {
        return 403;
    }
}
